import { render } from "./CommonLayout.vue?vue&type=template&id=72b0c02a&ts=true"
import script from "./CommonLayout.vue?vue&type=script&lang=ts"
export * from "./CommonLayout.vue?vue&type=script&lang=ts"

import "./CommonLayout.vue?vue&type=style&index=0&id=72b0c02a&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__